import { lazy, Suspense, memo } from 'react';
import { type LucideProps } from 'lucide-react';
import dynamicIconImports from 'lucide-react/dynamicIconImports';

interface IconRendererProps extends Omit<LucideProps, 'ref'> {
  name: string;
}

function IconRendererInner({ name, ...props }: IconRendererProps) {
  const iconName = name as keyof typeof dynamicIconImports;

  if (!dynamicIconImports[iconName]) {
    // Fallback to a circle for truly unknown icon names
    const FallbackIcon = lazy(dynamicIconImports['circle']);
    return (
      <Suspense fallback={<div style={{ width: props.size ?? 16, height: props.size ?? 16 }} />}>
        <FallbackIcon {...props} />
      </Suspense>
    );
  }

  const LucideIcon = lazy(dynamicIconImports[iconName]);

  return (
    <Suspense fallback={<div style={{ width: props.size ?? 16, height: props.size ?? 16 }} />}>
      <LucideIcon {...props} />
    </Suspense>
  );
}

export const IconRenderer = memo(IconRendererInner);
